module.exports = __webpack_public_path__ + "img/client-logo1.2f6183cb.png";